export default __webpack_public_path__ + "static/media/cssda-inn-Ronnie-Feng.feb406c2.webp";